module.exports = __webpack_public_path__ + "static/img/12.4d84c24.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/zh/12.png
// module id = 7gmF
// module chunks = 0